var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiverGreenIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81263 4.9396L3.27954 3.47271C3.57877 3.17348 3.68231 2.73134 3.56129 2.32584C3.46666 2.00876 3.36003 1.62758 3.28916 1.30162C3.22361 1.00015 2.95907 0.75 2.65056 0.75H1.81263C1.1956 0.75 0.688885 1.25213 0.756568 1.86544C1.2711 6.52754 4.97293 10.2294 9.63505 10.7439C10.2484 10.8116 10.7505 10.3049 10.7505 9.68781V8.84993C10.7505 8.54143 10.4993 8.28832 10.1958 8.2331C9.86093 8.17221 9.50666 8.07243 9.21027 7.97793C8.78443 7.84215 8.3111 7.9376 7.9951 8.2536L6.56088 9.68781",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81263 4.9396L3.27954 3.47271C3.57877 3.17348 3.68231 2.73134 3.56129 2.32584C3.46666 2.00876 3.36003 1.62758 3.28916 1.30162C3.22361 1.00015 2.95907 0.75 2.65056 0.75H1.81263C1.1956 0.75 0.688885 1.25213 0.756568 1.86544C1.2711 6.52754 4.97293 10.2294 9.63504 10.7439C10.2484 10.8116 10.7505 10.3049 10.7505 9.68781V8.84993C10.7505 8.54143 10.4993 8.28832 10.1958 8.2331C9.86093 8.17221 9.50666 8.07243 9.21027 7.97793C8.78443 7.84215 8.3111 7.9376 7.9951 8.2536L6.56088 9.68781",
    stroke: "#2C8C53",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiverGreenIc);
export default __webpack_public_path__ + "static/media/receiver_green_ic.894ca7d313170be320067837ea290033.svg";
export { ForwardRef as ReactComponent };